import { borderRadiusMd, spacing12x, spacing3x, spacing4x, spacing5x, spacing6x } from "@airhelp/design-tokens";
import { getSelectStyles } from "./Select.js";
export const getAutocompleteStyles = () => {
    return {
        ...getSelectStyles(),
        placeholder: (provided) => ({
            ...provided,
            color: "greyscale.500",
            marginRight: 0,
        }),
        control: (provided, state) => ({
            ...provided,
            cursor: "text",
            borderBottomRadius: state.menuIsOpen ? 0 : borderRadiusMd,
            flexDirection: "row",
            paddingY: `${spacing3x} !important`,
            paddingX: `${spacing4x} !important`,
            width: "auto",
            minWidth: "auto",
            minHeight: "auto",
            lineHeight: spacing5x,
            color: "font.primary",
            "> div": {
                padding: "unset",
                flexWrap: "nowrap",
                "> div": {
                    marginLeft: "0",
                    marginRight: "0",
                },
                "[class$=singleValue]": {
                    color: "inherit",
                },
            },
            _invalid: {
                borderColor: state.selectProps.tagColorScheme === "warning" ? "warning.600" : "danger.700",
                _hover: {
                    borderColor: { md: state.selectProps.tagColorScheme === "warning" ? "warning.700" : "danger.800" },
                },
                _focus: {
                    borderColor: "primary.500",
                },
            },
            input: {
                maxHeight: spacing6x,
            },
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            div: {
                padding: "unset",
                marginRight: 0,
                pointerEvents: "none",
            },
        }),
        inputContainer: (provided) => ({
            ...provided,
            cursor: "text",
        }),
    };
};
export const getAutocompleteWithIconStyles = () => {
    return {
        ...getAutocompleteStyles(),
        placeholder: (provided) => ({
            ...provided,
            color: "greyscale.500",
            marginRight: 0,
        }),
        control: (provided, state) => ({
            ...provided,
            cursor: "pointer",
            borderBottomRadius: state.menuIsOpen ? 0 : borderRadiusMd,
            paddingY: `${spacing3x} !important`,
            paddingLeft: `${spacing12x} !important`,
            paddingRight: `${spacing4x} !important`,
            width: "auto",
            minWidth: "auto",
            minHeight: "auto",
            lineHeight: spacing5x,
            color: "font.primary",
            "> div": {
                padding: "unset",
                whiteSpace: "pre",
                flexWrap: "nowrap",
                "> div": {
                    marginLeft: "0",
                    marginRight: "0",
                },
                "[class$=singleValue]": {
                    color: "inherit",
                },
            },
            _invalid: {
                borderColor: state.selectProps.tagColorScheme === "warning" ? "warning.600" : "danger.700",
                _hover: {
                    borderColor: { md: state.selectProps.tagColorScheme === "warning" ? "warning.700" : "danger.800" },
                },
                _focus: {
                    borderColor: "primary.500",
                },
            },
            input: {
                maxHeight: spacing6x,
            },
        }),
    };
};
